import { Module } from 'vuex';
import { RootState } from '@/plugins/store';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { EquipementState, state } from './state';

const equipementStatsModule: Module<EquipementState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default equipementStatsModule;
export type { EquipementState };
